<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  
  <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
          <i class="bi bi-arrow-left"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.question || 'Question' }}</h2>
        </div>
        <div class="header-action">
          <!-- <button class="btn-add" data-bs-toggle="offcanvas" data-bs-target="#branch" @click="add_new_staff()">
            <i class="bi bi-plus"></i>
          </button> -->

            <button class="btn-add"  @click="add_new_staff()">
            <i class="bi bi-plus"></i>
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <!-- CSV Upload Section -->
      <!--<div class="csv-section">-->
      <!--  <div class="section-header">-->
      <!--    <h3>Bulk Import</h3>-->
      <!--  </div>-->
      <!--  <div class="csv-card">-->
      <!--    <div class="csv-content">-->
      <!--      <div class="csv-icon">-->
      <!--        <i class="bi bi-file-earmark-spreadsheet"></i>-->
      <!--      </div>-->
      <!--      <div class="csv-info">-->
      <!--        <h4>Upload CSV File</h4>-->
      <!--        <p>Import multiple staff members at once</p>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <div class="csv-action">-->
      <!--      <label for="csv-upload" class="btn-csv">-->
      <!--        <i class="bi bi-cloud-upload"></i>-->
      <!--        Upload CSV-->
      <!--      </label>-->
      <!--      <input -->
      <!--        id="csv-upload" -->
      <!--        type="file" -->
      <!--        @change="handleFileUpload" -->
      <!--        accept=".csv" -->
      <!--        hidden-->
      <!--      />-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->

      <!-- Staff List Section -->
     <div class="staff-section">
  <div class="section-header">
    <!-- <p class="staff-count">{{ questionlist.length }} question</p> -->
  </div>

  <!-- Empty State -->
  <div v-if="questionlist.length === 0" class="empty-state text-center py-5">
    <div class="empty-icon">
      <i class="bi bi-clipboard-x fs-1 text-muted"></i>
    </div>
    <h5>No Question added</h5>
    <p class="text-muted">Add Question to get started</p>
  </div>

  <!-- Table -->
<div v-else class="table-responsive">
  <table class="table table-striped table-hover table-bordered align-middle" id="datatable">
    <thead class="table-light">
      <tr>
        <th class="text-sm">#</th>
        <th class="text-sm">Exam Type</th>
        <th class="text-sm">Subject</th>
        <th class="text-sm">Question</th>
        <th class="text-sm">Question Image</th>
        <th class="text-sm">Option 1</th>
        <th class="text-sm">Option 1 Image</th>
        <th class="text-sm">Option 2</th>
        <th class="text-sm">Option 2 Image</th>
        <th class="text-sm">Option 3</th>
        <th class="text-sm">Option 3 Image</th>
        <th class="text-sm">Option 4</th>
        <th class="text-sm">Option 4 Image</th>
        <th class="text-sm">Marks</th>
        <th class="text-sm">Answer</th>
        <th class="text-sm">Description</th>
        <th class="text-sm">Status</th>
        <th class="text-end text-sm">Actions</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(item, i) in questionlist" :key="i">
        <td class="text-sm">{{ i + 1 }}</td>
        <td class="text-sm">{{ item.exam_type_name || 'Not provided' }}</td>
        <td class="text-sm">{{ item.subject_name || 'Not provided' }}</td>
        <td class="text-sm">{{ item.questiontype || 'Not provided' }}</td>
        <td class="text-sm">
         <img v-if="item.questiontypeimg" :src="this.$hostname+'uploads/questiontype/'+item.questiontypeimg" alt="Option 1" width="50">
          <span v-else>Not provided</span>
        </td>

        <td class="text-sm">{{ item.option1 || 'Not provided' }}</td>
        <td class="text-sm">
          <img v-if="item.option1img" :src="this.$hostname+'uploads/options/'+item.option1img" alt="Option 1" width="50">
          <span v-else>Not provided</span>
        </td>

        <td class="text-sm">{{ item.option2 || 'Not provided' }}</td>
        <td class="text-sm">
          <img v-if="item.option1img" :src="this.$hostname+'uploads/options/'+item.option2img" alt="Option 1" width="50">
          <span v-else>Not provided</span>
        </td>

        <td class="text-sm">{{ item.option3 || 'Not provided' }}</td>
        <td class="text-sm">
        <img v-if="item.option1img" :src="this.$hostname+'uploads/options/'+item.option3img" alt="Option 1" width="50">
          <span v-else>Not provided</span>
        </td>

        <td class="text-sm">{{ item.option4 || 'Not provided' }}</td>
        <td class="text-sm">
          <img v-if="item.option1img" :src="this.$hostname+'uploads/options/'+item.option4img" alt="Option 1" width="50">
          <span v-else>Not provided</span>
        </td>

        <td class="text-sm">{{ item.marks || 'Not provided' }}</td>
         <td class="text-sm">{{ item.answer || 'Not provided' }}</td>
        <td class="text-sm">{{ item.description || 'Not provided' }}</td>
        <td class="text-sm">
          <span
            class="badge"
            :class="item.status == 1 ? 'bg-success' : 'bg-secondary'"
          >
            {{ item.status == 1 ? 'Active' : 'Inactive' }}
          </span>
        </td>

        <td class="text-end text-sm">
          <!-- <button
            class="btn btn-sm btn-outline-primary me-2"
            @click="editQuestion(item)"
          >
            <i class="bi bi-pencil"></i>
          </button> -->

          <button
            class="btn btn-sm btn-outline-danger"
            @click="deleteQuestion(item.id)"
          >
            <i class="bi bi-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>






</div>




















      
    </main>

 


<div class="modal fade show d-block" tabindex="-1" v-if="showmodal">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">Add Question</h5>
        <button type="button" class="btn-close" @click="showmodal = false"></button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="AddStaff">

          <div class="row">


          <div class="col-3 ">
              <label for="exam" class="form-label">Search Exam</label>
              <select class="form-select form-select-sm" id="exam" v-model="question.examid">
                <option value="">Select</option>
                <option v-for="(item, index) in examlist" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>



            <!-- Exam -->
            <div class="col-3 ">
              <label for="examtype" class="form-label">Search Exam Type </label>
              <select class="form-select form-select-sm" id="examtype" v-model="question.examtypeid">
                <option value="">Select</option>
                <option v-for="(item, index) in examtypelist" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>

            <!-- Subject -->
            <div class="col-3">
              <label for="subject" class="form-label">Search subject</label>
              <select class="form-select form-select-sm" id="subject" v-model="question.subjectid">
                <option value="">Select</option>
                <option v-for="(item, index) in subjectlist" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
 <div class="col-3">
              <label>{{ language?.marks || 'Marks' }}</label>
              <input type="number" class="form-control" v-model="question.marks" placeholder="Enter total marks">
            </div>

            <!-- Status -->
            <div class="col-3">
              <label>{{ language?.status || 'Status' }}</label>
              <select class="form-select" v-model="question.status">
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <!-- Question Text -->
            <div class="col-8">
              <label>{{ language?.questiontype || 'Question' }}</label>
              <input type="text" class="form-control" v-model="question.questiontype" placeholder="Enter question">
            </div>

            <!-- Question Image -->
            <div class="col-4">
              <label class="form-label">Question Image<br>
                <input type="file" style="display: none;" @change="eventFileUpload" class="form-control">
                <img v-if="imagePreview" :src="imagePreview" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
              </label>
            </div>

            <!-- Options with Images -->
            <template v-for="n in 4" :key="n">
              <!-- Option Text -->
              <div class="col-8">
                <label>{{ language[`option${n}`] || `Option ${n}` }}</label>
                <input type="text" class="form-control" v-model="question[`option${n}`]" :placeholder="`Enter option${n}`">
              </div>

              <!-- Option Image -->
              <div class="col-4">
                <label class="form-label" style="    display: inline-grid;">Option {{n}} Image <i class="fa fa-cloud-upload"></i><br>
                  <input type="file" style="display: none;" @change="uploadquestionimg($event, n)" class="form-control">
                  <img v-if="this[`imagePreview${n+1}`]" :src="this[`imagePreview${n+1}`]" style="max-width: 150px; border: 2px solid #000; border-radius: 5px;">
                </label>
              </div>
            </template>

            <!-- Marks -->


                  <div class="col-12">
              <label>{{ language?.Answer || 'Answer' }}</label>
              <input type="text" class="form-control" v-model="question.answer" placeholder="Enter Answer (A/B/C/D)">
            </div>


           
            <!-- Question Description (Full width) -->
            <div class="col-12">
              <label>{{ language?.question_description || 'Question Description' }}</label>
              <input type="text" class="form-control" v-model="question.description" placeholder="Enter question description">
            </div>

          </div> <!-- row -->

          <!-- Form Actions -->
          <div class="form-actions mt-3 text-end">
            <button type="submit" class="btn btn-primary">{{ question.id ? 'Update' : 'Save' }}</button>
            <button type="button" class="btn btn-secondary" @click="showmodal = false">Cancel</button>
          </div>

        </form>
      </div>

    </div>
  </div>
</div>

<!-- Backdrop -->
<div v-if="showmodal" class="modal-backdrop fade show"></div>





























  </div>
</template>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  mounted() { 
    this.getBranches();
  },
  data() {
    const todayDate = new Date().toISOString().slice(0, 10);
    return { 

    showmodal:false,


    imagePreview:'',
    imagePreview2:'',
    imagePreview3:'',
    imagePreview4:'',
    imagePreview5:'',




      loading: false,
      error: null,
      isUserLogged: false,
      user_details: [],
      language: this.getLocalStorageArray('lang'),
      question: {
        subjectid: '',
        examid: '',
        questiontype: '',
        questiontypeimg: '',
        option1: '',
        option1img: '',
        option2: '',
        option2img: '',
        option3: '',
        option3img: '',
        option4: '',
        option4img: '',
        marks: '',
        answer:'',
        description: '',
        status: 1,
      },
      subjectlist: [], 
      examlist:[],
      examtypelist:[],
      questionlist:[],
      branch_name: '',
    }
  },
  methods: {
    add_new_staff() {
     this.subject= {
        name: '',
        status: 1,
        code: '',
        description: '',
      };



      this.showmodal=true;

    },
    
    goBack() {
      this.$router.go(-1);
    },
    
    goprevious() {
      this.$router.push("/branch");
    },

    async getBranches() {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;
        axios.post("getaddquestion").then((response) => {
          self.examlist = response.data.examlist;
          self.subjectlist = response.data.subjectlist;
          self.questionlist = response.data.questionlist;
          self.language = response.data.language;
          self.examtypelist = response.data.examtypelist;
          localStorage.setItem('lang', response.data.language);
        }).then(() => {
          self.initializeHomeContent();

             $("#subject").select2({
                        width: '250px', 
                        placeholder:"Search Subject Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                     }).on('change', function (event) {
                          question.subjectid = event.target.value;
                                       
                            
                        });



                        
             $("#exam").select2({
                        width: '250px', 
                        placeholder:"Search Exam Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
                    
                        question.examid = event.target.value;
                            
                          
                            
                        });


                           $("#examtype").select2({
                        width: '250px', 
                        placeholder:"Search Exam Type Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
                    
                                
                        question.examtypeid = event.target.value;
                            
                        });
























        self.initializeHomeContent();











        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

    AddStaff() {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        if (self.question.subjectid == '') {
          self.$swal.fire("Subject is Required!");
        } else {
          axios.post("addquestion", self.question,
           {
            headers: {
               'Content-Type': 'multipart/form-data' 
          }}

          ).then((response) => {
            self.examlist = response.data.examlist;
            self.language = response.data.language;
            self.$swal.fire(response.data.message);
            
            if (response.data.success) {
              // Reset form
              self.showmodal = false;
              self.question={
                      subjectid: '',
                      examid: '',
                      examtypeid: '',
                      questiontype: '',
                      questiontypeimg: '',
                      option1: '',
                      option1img: '',
                      option2: '',
                      option2img: '',
                      option3: '',
                      option3img: '',
                      option4: '',
                      option4img: '',
                      marks: '',
                      answer:'',
                      description: '',
                      status: 1,
                    };
              // window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
            }
          }).then(() => {
            self.initializeHomeContent();
          }).catch((err) => {
            console.error(err);
          });
        }
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

    editStaff(exam) {
      this.exam = {...exam};
      window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
    }, 

    deleteQuestion(id = "") {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        this.$swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post("deletequestion", { id: id }).then((response) => {
              self.examlist = response.data.examlist;
              self.subjectlist = response.data.subjectlist;
              self.questionlist = response.data.questionlist;

              self.$swal.fire(response.data.message);
            }).then(() => {
               
            }).catch((err) => {
              self.$swal.fire("Error!", "Something went wrong.", "error");
            });
          }
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },

    async handleFileUpload(e) {
      var self = this;
      const file = e.target.files[0];
      if (!file) return;
      
      const formData = new FormData();
      formData.append("csv_file", file);

      try {
        const response = await axios.post("importcsvstaff", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        self.stafflist = response.data.stafflist || self.stafflist;
        self.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.msg || 'CSV imported successfully'
        });
        this.getBranches(); // Refresh the list
      } catch (error) {
        console.error("Upload Failed:", error);
        self.$swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: error.response?.data?.msg || 'Failed to import CSV'
        });
      }
    },


        eventFileUpload(event) {
                this.question.questiontypeimg = event.target.files[0]; // Store the selected file
                const file = event.target.files[0]; // Correctly define 'file'
                    if (file) {
                      this.question.questiontypeimg = file; // Store the selected file
                      this.imagePreview = URL.createObjectURL(file); // Create image preview
                    }
            },

             uploadquestionimg(event, optionNo) {
                            const file = event.target.files[0];
                            if (!file) return;

                            if (optionNo === 1) {
                                this.question.option1img = file;
                                this.imagePreview2 = URL.createObjectURL(file);

                            } else if (optionNo === 2) {
                                this.question.option2img = file;
                                this.imagePreview3 = URL.createObjectURL(file);

                            } else if (optionNo === 3) {
                                this.question.option3img = file;
                                this.imagePreview4 = URL.createObjectURL(file);

                            } else if (optionNo === 4) {
                                this.question.option4img = file;
                                this.imagePreview5 = URL.createObjectURL(file);
                            }
                            },




          initializeHomeContent() {
                                this.$nextTick(() => {
                                  const table = $("#datatable");
                              
                                  if ($.fn.DataTable.isDataTable(table)) {
                                    table.DataTable().destroy();
                                  }
                              
                                  table.DataTable({
                                    pageLength: 10,
                                    searching: true,
                                    ordering: true
                                  });
                                });
                              },  


                      destroyDataTable() {
                        if ($.fn.DataTable.isDataTable("#datatable")) {
                          $("#datatable").DataTable().destroy();
                        }
                      },












  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.back-button:active {
  background: rgba(255, 255, 255, 0.2);
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-add {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s;
}

.btn-add:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.95);
}

.main-content {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.section-header {
  margin-bottom: 16px;
}

.section-header h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-count {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.csv-section {
  margin-bottom: 24px;
}

.csv-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.csv-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.csv-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #4caf50;
}

.csv-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  color: #2c3e50;
}

.csv-info p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.btn-csv {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-csv:active {
  background: #388e3c;
  transform: scale(0.98);
}

.staff-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.staff-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.staff-card-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.staff-avatar {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #0056c2;
  flex-shrink: 0;
}

.staff-info {
  flex: 1;
}

.staff-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.staff-header h4 {
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.badge-admin {
  background: rgba(156, 39, 176, 0.1);
  color: #9c27b0;
}

.badge-staff {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.staff-details p {
  margin: 4px 0;
  font-size: 14px;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  gap: 8px;
}

.staff-status {
  margin-top: 8px;
}

.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.staff-actions {
  display: flex;
  padding: 0 16px 16px;
  gap: 8px;
  justify-content: flex-end;
}

.btn-action {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-action:active {
  transform: scale(0.95);
}

.btn-action.edit {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.btn-action.delete {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Offcanvas Styles */
.offcanvas-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
}

.offcanvas-back {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  margin-right: 12px;
}

.offcanvas-back:active {
  background: #f5f7fa;
}

.offcanvas-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.offcanvas-body {
  padding: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.form-control, .form-select {
  width: 100%;
  padding: 5px 6px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 12px;
  transition: border-color 0.3s;
}

.form-control:focus, .form-select:focus {
  outline: none;
  border-color: #0056c2;
  box-shadow: 0 0 0 3px rgba(0, 86, 194, 0.1);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #0056c2;
  color: white;
}

.btn-primary:active {
  background: #003a75;
}

.btn-secondary {
  background: #f5f7fa;
  color: #7f8c8d;
}

.btn-secondary:active {
  background: #e9ecef;
}

@media (max-width: 480px) {
  .csv-card {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .staff-card-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  
  .staff-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.text-sm{
    font-size: 14px;
}
</style>